import { IDatePickerProps } from "@fluentui/react";
import React, { useState } from "react";

import { Stack } from "../../layouts/stack/Stack";
import { DatePicker } from "../date/DatePicker";

export interface DateRangePickerProps extends Pick<IDatePickerProps, "minDate" | "maxDate" | "formatDate"> {
    startValue?: Date;
    endValue?: Date;
    fromLabel?: string;
    toLabel?: string;
    fromPlaceholder?: string;
    toPlaceholder?: string;
    testId?: string;
    onDateStartSelect(date?: Date): void;
    onDateEndSelect(date?: Date): void;
}

export const DateRangePicker: React.FunctionComponent<DateRangePickerProps> = (props: DateRangePickerProps) => {
    const [endMinDate, setEndMinDate] = useState<Date | undefined>(props.startValue);
    const [startMaxDate, setStartMaxDate] = useState<Date | undefined>(props.endValue);

    const setDateStartAndRestrictSelection = (date?: Date): void => {
        props.onDateStartSelect(date);
        setEndMinDate(date);
    };

    const setDateEndAndRestrictSelection = (date?: Date): void => {
        const milisecondsInADay = 24 * 60 * 60 * 1000;
        const newDate = date ? new Date(date.getTime() + milisecondsInADay - 1) : undefined;

        props.onDateEndSelect(newDate);
        setStartMaxDate(newDate);
    };

    return (
        <Stack horizontal={true} tokens={{ childrenGap: 16 }}>
            <DatePicker
                onDateSelect={setDateStartAndRestrictSelection}
                formatDate={props.formatDate}
                value={props.startValue}
                label={props.fromLabel}
                placeholder={props.fromPlaceholder || "From"}
                minDate={props.minDate}
                maxDate={startMaxDate}
                styles={{ root: { width: "100%", margin: -1 } }}
                testId={`${props.testId}-from`}
            />
            <DatePicker
                onDateSelect={setDateEndAndRestrictSelection}
                formatDate={props.formatDate}
                value={props.endValue}
                label={props.toLabel}
                placeholder={props.toPlaceholder || "To"}
                minDate={endMinDate}
                maxDate={props.maxDate}
                styles={{ root: { width: "100%", margin: -1 } }}
                testId={`${props.testId}-to`}
            />
        </Stack>
    );
};
